import { UserRole } from '../../../domain/users/models/User';

export interface ActiveUserInfo {
    id: string;
    email: string;
    username: string;
    role?: UserRole;
    photoUrl?: string;
}

export interface AppState {
    activeUserInfo?: ActiveUserInfo;
    isServiceUnavailable: boolean;
    disclaimerDismissed: boolean;
}

export const initialState: AppState = {
    activeUserInfo: undefined,
    isServiceUnavailable: false,
    disclaimerDismissed: false,
};
